import { Component, computed, inject, input, output } from '@angular/core';
import { RouterLinkWithHref } from '@angular/router';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { LoaderComponent } from '@progress/kendo-angular-indicators';
import { IconService } from '@unity/services/icon.service';
import { QuickActionProps } from '@unity/utils/types';

@Component({
  selector: 'unity-action-cancel-shared',
  imports: [LoaderComponent, KENDO_BUTTON, RouterLinkWithHref],
  templateUrl: './action-cancel-shared.component.html',
  styleUrl: './action-cancel-shared.component.scss',
})
export class ActionCancelSharedComponent<TInput extends QuickActionProps> {
  private readonly iconService = inject(IconService);
  public readonly $disabled = input.required<boolean>({ alias: 'disabled' });
  protected readonly $cancelIcon = computed(() => this.iconService.getSVGIcon('cancelIcon'));
  public readonly $action = input.required<TInput>({ alias: 'action' });
  public readonly clickEvent = output();

  protected onClick(event: Event) {
    const disabled = this.$disabled();
    if (disabled) {
      event.preventDefault();
      return;
    }
    const action = this.$action();
    if (action.callback) {
      this.clickEvent.emit();
      action.callback();
    } else {
      this.clickEvent.emit();
    }
  }
}
